import { WebsiteBuilderItemBase } from './website-builder-item-base';
import { IWebsiteDocument } from '../../api-response/auth/website-builder';
import { WebsiteBuilderView } from '../website-builder-view';

export class WebsiteBuilderItemDocuments extends WebsiteBuilderItemBase {
    name = 'Documents and Forms';
    navName = 'Documents';
    navLink = 'documents';

    isPresentFlag: boolean = false;
    styleType: string = 'list';
    documents: any[] = [];

    isOpened: boolean = false;
    isDisable: boolean = false;

    set isPresent(val) {
        this.resetMenu(val);
        this.isPresentFlag = val;
    }

    get isPresent() {
        return this.isPresentFlag;
    }

    resetMenu(val) {
        const wb = this as any; // bound website builder context

        if (!val && wb.webView == WebsiteBuilderView.documents && this.isPresentFlag) {
            wb.webView = WebsiteBuilderView.index;
            wb.setCurrentMenu('home');
        }
    }

    set value(item: IWebsiteDocument) {
        this.isPresent = item.status;
        this.styleType = item.style;
        this.documents = [{ // todo: check it
            name: item.document,
            show: true
        }];
        this.priority = item.priority;
    }

    get value(): IWebsiteDocument {
        return {
            style: this.styleType,
            document: this.documents.length && this.documents[0].document ? this.documents[0].document : '',
            status: this.isPresent,
            priority: this.priority
        };
    }

    constructor(wbContext) {
        super();
        this.resetMenu = this.resetMenu.bind(wbContext);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-documents.ts